module.exports = __webpack_public_path__ + "img/avue.e15a0b4d.png";